<template>
    <div class="inventario-modal-container">
        <!-- DataTable para mostrar los datos -->
        <div v-if="transactions.length > 0 && !loading" class="table-container">
            <div class="inventario-toolbar">
                <p v-if="fechaMasReciente" class="inventario-fecha">
                    <i class="fa-regular fa-clock"></i>
                    Actualizado: {{ fechaMasReciente }}
                </p>
                <button type="button" @click="loadProductos" class="btn-actualizar" :disabled="loading">
                    <i class="fas fa-sync-alt"></i> Actualizar
                </button>
            </div>
            <DataTable :columns="columns" :options="options" :data="transactions" class="table tablesorter" width="100%"
                @click="seleccionarMedicamento">
                <thead>
                    <tr>
                        <th style="width: 8%">#</th>
                        <th data-priority="1" style="width: 45%">NOMBRE</th>
                        <th style="text-align: center; width: 15%">CANTIDAD</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(medicamento, index) in transactions" :key="index" :data-index="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ medicamento.NOMBRE }}</td>
                        <td class="text-center">{{ medicamento.CANTIDAD }}</td>
                    </tr>
                </tbody>
            </DataTable>
        </div>

        <!-- Indicador de carga -->
        <div v-if="loading" class="loading-container text-center">
            <div class="spinner-border text-primary" role="status" style="width: 2rem; height: 2rem;">
                <span class="visually-hidden">Cargando...</span>
            </div>
            <div class="mt-2">
                <p class="text-muted mb-0">Cargando inventario...</p>
            </div>
        </div>

        <!-- Mensaje cuando no hay datos -->
        <div v-if="!loading && transactions.length === 0" class="empty-container text-center">
            <i class="fas fa-box-open text-muted" style="font-size: 2rem; opacity: 0.5;"></i>
            <h6 class="text-muted mt-2">No hay medicamentos disponibles</h6>
            <p class="text-muted small">El inventario está vacío</p>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import readXlsxFile from "read-excel-file";
import DataTable from 'datatables.net-vue3'
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-responsive';

DataTable.use(DataTablesCore);

export default {
    name: "InventarioComponent",
    props: {
    },
    components: {
        DataTable
    },
    data() {
        return {
            loading: false,
            isMobile: this.$isMobile,
            transactions: [],
            items: [],
            selectedFile: null,
            responseData: null,
            fechaMasReciente: null,
            columns: [
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        const index = meta.row + 1;
                        return index;
                    }
                },
                { data: 'NOMBRE' },
                { data: 'CANTIDAD', className: 'text-center' }
            ],
            options: {
                responsive: true,
                "ordering": false,
                "paging": true,
                "info": true,
                "searching": true,
                "lengthChange": false,
                columnDefs: [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: -1 }
                ],
                lengthMenu: [
                    [5, 15, 25, 35, 50, -1],
                    [5, 15, 25, 35, 50, "All"],
                ],
                pageLength: 5,
                "language": {
                    "search": "Buscar:",
                    "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "searchPlaceholder": "Ingrese algún dato",
                    "zeroRecords": "Lo sentimos, no se encontraron resultados",
                    "processing": "Buscando. Espere por favor...",
                    "sLengthMenu": "Mostrar _MENU_ registros",
                    "oPaginate": {
                        "sFirst": "Primero",
                        "sLast": "Último",
                        "sNext": "Siguiente",
                        "sPrevious": "Anterior"
                    },
                }
            }

        };
    },
    methods: {

        showSuccessToast(message) {
            // Implementar según tu sistema de notificaciones
            if (this.$toast) {
                this.$toast.success(message);
            } else {
                alert('Éxito: ' + message);
            }
        },

        showErrorToast(message) {
            // Implementar según tu sistema de notificaciones
            if (this.$toast) {
                this.$toast.error(message);
            } else {
                alert('Error: ' + message);
            }
        },

        showWarningToast(message) {
            // Implementar según tu sistema de notificaciones
            if (this.$toast) {
                this.$toast.warning(message);
            } else {
                alert('Advertencia: ' + message);
            }
        },

        showInfoToast(message) {
            // Implementar según tu sistema de notificaciones
            if (this.$toast) {
                this.$toast.info(message);
            } else {
                alert('Info: ' + message);
            }
        },

        async loadProductos() {
            this.loading = true;

            try {
                const response = await this.$https.post('/evaluacion/getLoadInventario', {}, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                });

                if (response.data.code === 200) {
                    console.log('Datos recibidos:', response.data);

                    // Guardar la respuesta completa para mostrar información adicional
                    this.responseData = response.data;

                    // Calcular la fecha más reciente
                    this.calcularFechaMasReciente(response.data.datos.fechas_insert);

                    // Transformar los datos para que coincidan con el formato del DataTable
                    const inventario = response.data.datos.inventario;
                    this.transactions = inventario.map(item => ({
                        NOMBRE: item.nombre,
                        CANTIDAD: item.cantidad
                    }));

                    console.log('Datos transformados:', this.transactions);

                    if (this.transactions.length > 0) {
                        this.showSuccessToast(`Inventario cargado: ${this.transactions.length} productos encontrados`);
                        this.loading = false;

                        // Forzar la redraw del DataTable después de un breve delay
                        this.$nextTick(() => {
                            setTimeout(() => {
                                const dataTable = this.$el.querySelector('.dataTables_wrapper');
                                if (dataTable) {
                                    const event = new Event('resize');
                                    window.dispatchEvent(event);
                                }
                            }, 100);
                        });
                    } else {
                        this.showInfoToast('No hay productos en el inventario');
                    }
                } else if (response.data.code === 204) {
                    console.log('No hay productos en el inventario:', response.data);

                    // Limpiar los datos y mostrar mensaje
                    this.transactions = [];
                    this.responseData = response.data;
                    this.showInfoToast('No hay productos en el inventario');
                } else {
                    this.showErrorToast(`Error en el servidor: ${response.data.message || 'Código de respuesta inesperado'}`);
                }




            } catch (error) {
                console.error('Error loadProductos:', error);

                if (error.response) {
                    this.showErrorToast(`Error del servidor: ${error.response.data?.message || error.response.statusText}`);
                } else if (error.request) {
                    this.showErrorToast('Error de conexión. Verifica tu conexión a internet.');
                } else {
                    this.showErrorToast('Error al cargar el inventario. Intenta nuevamente.');
                }
            } finally {
                this.loading = false;
            }
        },

        calcularFechaMasReciente(fechasInsert) {
            if (!fechasInsert || fechasInsert.length === 0) {
                this.fechaMasReciente = null;
                return;
            }

            // Ordenar las fechas de más reciente a más antigua
            const fechasOrdenadas = fechasInsert
                .map(fecha => new Date(fecha.fecha_ingreso))
                .sort((a, b) => b - a); // Orden descendente (más reciente primero)

            // Obtener la fecha más reciente
            const fechaMasReciente = fechasOrdenadas[0];

            // Formatear la fecha para mostrar
            this.fechaMasReciente = this.formatFechaCorta(fechaMasReciente);
        },

        formatFechaCorta(fecha) {
            if (!fecha) return '';

            const fechaObj = new Date(fecha);

            // Formatear la fecha en formato DD-MM-YY HH:mm:ss
            const year = String(fechaObj.getFullYear()).slice(-2); // Solo los últimos 2 dígitos del año
            const month = String(fechaObj.getMonth() + 1).padStart(2, '0');
            const day = String(fechaObj.getDate()).padStart(2, '0');
            const hours = String(fechaObj.getHours()).padStart(2, '0');
            const minutes = String(fechaObj.getMinutes()).padStart(2, '0');
            const seconds = String(fechaObj.getSeconds()).padStart(2, '0');

            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        },

        seleccionarMedicamento(event) {
            // Obtener el elemento de la fila clickeada
            const rowElement = event.target.closest("tr");

            // Verificar si la fila es válida
            if (!rowElement) return;

            // Obtener el índice del dataset (deberás agregar data-index a tus filas)
            const dataIndex = rowElement.dataset.index;
            // Si no hay data-index, usar el enfoque alternativo
            const rowIndex = dataIndex !== undefined ? parseInt(dataIndex) : this.getActualDataIndex(rowElement);

            if (rowIndex < 0 || !this.transactions[rowIndex]) return;

            const medicamento = this.transactions[rowIndex];

            // Emitir el evento con el nombre del medicamento
            this.$emit('medicamento-seleccionado', medicamento.NOMBRE);

            // Cerrar el modal
            this.$emit('cerrar-modal');
        },

        // Método auxiliar para encontrar el índice real en los datos
        getActualDataIndex(rowElement) {
            const nombre = rowElement.cells[1].textContent; // Asumiendo que la columna 1 es el nombre
            return this.transactions.findIndex(item => item.NOMBRE === nombre);
        },

        formatFecha(fechaString) {
            if (!fechaString) return 'N/A';
            const fecha = new Date(fechaString);
            return fecha.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },

        getTimeFromFecha(fechaString) {
            if (!fechaString) return 'N/A';
            const fecha = new Date(fechaString);
            return fecha.toLocaleTimeString('es-ES', {
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        showFechaDetails(fecha, index) {
            const fechaFormateada = this.formatFecha(fecha.fecha_ingreso);
            const horaFormateada = this.getTimeFromFecha(fecha.fecha_ingreso);

            this.showInfoToast(`Subida #${index + 1}: ${fechaFormateada} a las ${horaFormateada}`);
        }

    },
    mounted() {
        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }


        this.loadProductos()

    }
}
</script>

<style scoped>
/* Contenedor principal para el modal */
.inventario-modal-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.table-container {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.inventario-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 12px;
}

.inventario-fecha {
    margin: 0;
    color: #eb1265;
    font-weight: bold;
    font-size: 0.78rem;
}

.inventario-fecha i {
    margin-right: 6px;
    color: #0078be;
}

.btn-actualizar {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    padding: 7px 12px;
    border: 1px solid #d7e8f5;
    border-radius: 10px;
    background: #e8f4fc;
    color: #0078be;
    font-size: 0.78rem;
    font-weight: 700;
}

.btn-actualizar:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.loading-container {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
}

.empty-container {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
}

/* Mejorar la tabla */
.table {
    margin-bottom: 0;
    font-size: 0.9rem;
}

.table thead th {
    background: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    font-weight: 600;
    color: #495057;
    padding: 0.75rem 0.5rem;
    font-size: 0.85rem;
    position: sticky;
    top: 0;
    z-index: 10;
}

.table tbody td {
    padding: 0.5rem;
    vertical-align: middle;
    border-bottom: 1px solid #e9ecef;
}

.table tbody tr:hover {
    background-color: #e8f4fc;
    cursor: pointer;
}

.table tbody td:last-child {
    font-weight: 700;
    color: #0078be;
}

:deep(.dataTables_wrapper) {
    font-size: 0.78rem;
}

:deep(.dataTables_wrapper > .row:first-child) {
    margin-left: 0;
    margin-right: 0;
}

:deep(.dataTables_wrapper > .row:first-child > [class*="col-"]) {
    flex: 0 0 100%;
    width: 100%;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
}

:deep(.dataTables_wrapper > .row:first-child > [class*="col-"]:empty) {
    display: none;
}

:deep(.dataTables_filter) {
    float: none;
    width: 100%;
    margin: 0 0 8px;
    text-align: left;
}

:deep(.dataTables_filter label) {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin: 0;
}

:deep(.dataTables_filter input) {
    flex: 1;
    width: 100% !important;
    min-width: 0;
    height: 32px;
    margin: 0;
    border: 1px solid #e3eaf2;
    border-radius: 8px;
    font-size: 0.75rem;
}

:deep(.dataTables_info),
:deep(.dataTables_paginate) {
    margin-top: 8px;
    font-size: 0.72rem;
}

/* Responsive */
@media (max-width: 768px) {
    .table {
        font-size: 0.8rem;
    }

    .table thead th,
    .table tbody td {
        padding: 0.4rem 0.3rem;
    }
}

/* Asegurar que la paginación se muestre correctamente */
.dataTables_wrapper {
    width: 100%;
    margin-top: 1rem;
}

.dataTables_paginate {
    margin-top: 0.5rem;
    text-align: center;
}

.dataTables_info {
    margin-top: 0.5rem;
    text-align: center;
}

.dataTables_length {
    margin-bottom: 0.5rem;
}

.dataTables_filter {
    float: none;
    width: 100%;
    margin: 0 0 8px;
    text-align: left;
}

.dataTables_filter label {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin: 0;
}

.dataTables_filter input {
    flex: 1;
    width: 100% !important;
    min-width: 0;
    margin: 0;
}

/* Asegurar que los controles de paginación sean visibles */
.paginate_button {
    display: inline-block !important;
    margin: 0 2px;
    padding: 5px 10px;
    border: 1px solid #ddd;
    background: #fff;
    color: #333;
    cursor: pointer;
    border-radius: 3px;
}

.paginate_button:hover {
    background: #f5f5f5;
}

.paginate_button.current {
    background: #0078be;
    color: white;
    border-color: #0078be;
}

.paginate_button.disabled {
    color: #ccc;
    cursor: not-allowed;
}

/* Estadísticas principales */
.stats-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

.stat-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 15px;
    padding: 1.5rem;
    color: white;
    display: flex;
    align-items: center;
    gap: 1rem;
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
}

.stat-card.secondary {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    box-shadow: 0 8px 25px rgba(240, 147, 251, 0.3);
}

.stat-card.secondary:hover {
    box-shadow: 0 12px 35px rgba(240, 147, 251, 0.4);
}

.stat-icon {
    font-size: 2rem;
    opacity: 0.9;
}

.stat-content {
    flex: 1;
}

.stat-number {
    font-size: 1.8rem;
    font-weight: bold;
    line-height: 1;
}

.stat-label {
    font-size: 0.9rem;
    opacity: 0.9;
    margin-top: 0.25rem;
}

/* Información de actualización */
.update-info {
    background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
    border-radius: 15px;
    padding: 1.5rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.update-header {
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
}

.update-time {
    color: #34495e;
    font-weight: 500;
    font-size: 0.95rem;
}

/* Timeline de fechas */
.timeline-container {
    background: white;
    border-radius: 15px;
    padding: 1.5rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.timeline-header {
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #ecf0f1;
}

.timeline {
    position: relative;
    max-height: 300px;
    overflow-y: auto;
}

.timeline-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 1.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0.5rem;
    border-radius: 10px;
}

.timeline-item:hover {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    transform: translateX(5px);
}

.timeline-marker {
    position: relative;
    margin-right: 1rem;
    flex-shrink: 0;
}

.marker-dot {
    width: 12px;
    height: 12px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    border: 3px solid white;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.marker-line {
    position: absolute;
    left: 50%;
    top: 12px;
    width: 2px;
    height: calc(100% + 1.5rem);
    background: linear-gradient(to bottom, #667eea, #764ba2);
    transform: translateX(-50%);
}

.timeline-content {
    flex: 1;
    min-width: 0;
}

.timeline-date {
    font-weight: bold;
    color: #2c3e50;
    font-size: 0.95rem;
    margin-bottom: 0.25rem;
}

.timeline-time {
    color: #7f8c8d;
    font-size: 0.85rem;
    margin-bottom: 0.25rem;
}

.timeline-number {
    color: #667eea;
    font-size: 0.8rem;
    font-weight: 500;
}

.empty-timeline {
    text-align: center;
    color: #7f8c8d;
    padding: 2rem 1rem;
}

.empty-timeline i {
    font-size: 2rem;
    margin-bottom: 1rem;
    opacity: 0.5;
}

.empty-timeline p {
    margin: 0;
    font-size: 0.9rem;
}

/* Scrollbar personalizado */
.timeline::-webkit-scrollbar {
    width: 6px;
}

.timeline::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.timeline::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 3px;
}

.timeline::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}

/* Responsive */
@media (max-width: 768px) {
    .stats-container {
        grid-template-columns: 1fr;
    }

    .stat-card {
        padding: 1rem;
    }

    .stat-number {
        font-size: 1.5rem;
    }
}

/* Contenedor de carga */
.loading-container {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 15px;
    padding: 3rem 2rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    border: 2px dashed #dee2e6;
}

.loading-container .spinner-border {
    border-width: 0.25em;
}

.loading-container h5 {
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.loading-container p {
    margin-bottom: 0;
    font-size: 0.95rem;
}
</style>